import { jwtDecode } from 'jwt-decode';

import { deleteCookie, getCookieFromName } from '../../shared/utilities/cookies';

import { getEnvRequired } from '../../shared/utilities/env';

import { AgentDetails, EtsJWTPayload } from './types';

const oldTravelSuiteToken = 'token';
const travelSuiteToken = 'ets_token';

export function checkAuthFromCookie(
    login: (username: string, id: number | string) => void,
    logout: () => void,
    markAsImpersonated: () => void,
    isAuthenticated: boolean,
): boolean {
    const username = decodeURI(getCookieFromName('username'));
    const legacyEtsToken = getCookieFromName(oldTravelSuiteToken);
    const impersonate = getCookieFromName('impersonate');

    let id;
    try {
        id = getIdFromToken(legacyEtsToken);
    } catch {
        if (isAuthenticated) {
            logout();
        }
        return false;
    }
    if (!isAuthenticated && impersonate) {
        markAsImpersonated();
    }
    if (!isAuthenticated) {
        login(username, id);
    }

    return true;
}

function getIdFromToken(token: string): number {
    const decodedToken = jwtDecode<{ sub: string; accountId: string }>(token);
    const id = parseInt(decodedToken['sub']);

    if (!Number.isInteger(id)) {
        throw new Error('JWT "sub" property is missing a valid "id"');
    }

    return id;
}

export function getAgentDetailsFromEtsToken(): AgentDetails | null {
    const etsToken = getCookieFromName(travelSuiteToken);
    if (!etsToken) {
        return null;
    }

    const {
        agent_id,
        user_id,
        user_name,
        user_firstname,
        user_lastname,
        user_email,
        agency_id,
        agency_name,
    } = jwtDecode<EtsJWTPayload>(etsToken);
    return {
        agentId: agent_id,
        userId: user_id,
        userFirstName: user_firstname,
        userLastName: user_lastname,
        userName: user_name,
        userEmail: user_email,
        agencyId: agency_id,
        agencyName: agency_name,
    };
}

export function getAuthToken(shouldUseEtsToken = false) {
    return getCookieFromName(shouldUseEtsToken ? travelSuiteToken : oldTravelSuiteToken);
}

export function deleteAppCookies(): void {
    deleteCookie('username');
    deleteCookie(oldTravelSuiteToken);
    deleteCookie(travelSuiteToken);
    deleteCookie('id');
    deleteCookie('impersonate');
}

export function redirectToLogin(pathname = '') {
    const etsUrl = getEnvRequired('TRAVEL_SUITE_URL');
    const appBasename = getEnvRequired('APP_BASENAME');
    const etsLoginRouteWithRedirect = `${etsUrl}/login?redirect_path=${etsUrl}${appBasename}${pathname}`;

    deleteAppCookies();
    window.location.replace(etsLoginRouteWithRedirect);
}

export function logoutAndNavigateToLogin() {
    const etsUrl = getEnvRequired('TRAVEL_SUITE_URL');
    const loginUrl = `${etsUrl}/login`;

    deleteAppCookies();

    window.location.assign(loginUrl);
}
